export interface Testimonial {
  text: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    text: 'Insegno inglese alle medie da undici anni e la domenica sera era diventata sinonimo di preparazione. Con ENGLISH TEACHER PRO™ apro la Lesson Library, scelgo il livello e l’obiettivo, adatto due attività e la lezione è pronta in venti minuti. Il Lesson Builder da 45 minuti è quello che uso di più: rispecchia esattamente la durata delle mie ore.',
    author: 'Francesca M.',
    role: 'Insegnante di inglese, scuola secondaria',
    location: 'Bologna, Italia',
  },
  {
    text: 'Faccio lezioni private a studenti dai 14 ai 50 anni e ogni profilo chiedeva un materiale diverso. Il 1-TO-1 & SMALL GROUP TEACHING KIT™ mi ha risolto il problema: strutture pronte, speaking task e progress tracker. In un mese ho preso tre studenti in più perché avevo finalmente il tempo di seguirli davvero.',
    author: 'Giulia R.',
    role: 'Tutor privata di inglese',
    location: 'Torino, Italia',
  },
  {
    text: 'Lavoro solo online e la difficoltà era tenere alta l’attenzione allo schermo. L’ONLINE ENGLISH CLASSROOM KIT™ ha attività pensate proprio per questo, comprese le alternative da usare quando la condivisione dello schermo non funziona. Le mie lezioni sono più dinamiche e i no-show sono calati.',
    author: 'Marco B.',
    role: 'English teacher online, adulti e business',
    location: 'Milano, Italia',
  },
  {
    text: 'Insegno in una scuola di lingue con classi di livelli molto diversi, dall’A1 al C1. Avere il materiale già organizzato per livello, competenza e durata mi permette di preparare tre gruppi diversi nello stesso pomeriggio. I role play di vita reale sono i preferiti dei miei studenti adulti.',
    author: 'Chiara D.',
    role: 'Docente presso scuola di lingue',
    location: 'Firenze, Italia',
  },
  {
    text: 'Dopo vent’anni di insegnamento avevo cartelle piene di schede che non trovavo mai al momento giusto. Qui tutto è in un unico posto e collegato: grammatica, speaking, homework e valutazioni. I printables e i tracker mi hanno rimesso in ordine i registri dei progressi, e recupero almeno cinque ore a settimana.',
    author: 'Alessandro P.',
    role: 'Insegnante di inglese e formatore',
    location: 'Napoli, Italia',
  },
]
